<template>
  <v-dialog :value="value" @input="close()" transition="fade-transition" max-width="1000px">
    <v-card style="min-width:400px">
      <v-card-title class="headline">Influencers for '{{campaign.name}}'</v-card-title>
      <v-card-text>
        <v-layout column>
          <v-row>
            <v-col cols="4" sm="6" md="4">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                  min-height="195px"
                >
                  <v-card-title class="title">Overall Summary</v-card-title>
                  <v-card-subtitle>
                    <p class="pa-0 ma-0 custom-font" v-for="(total, index) in overall" :key="index">
                      {{total.title}}: {{total.value | thousandSeprator}}
                    </p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="4" sm="6" md="4">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                  min-height="195px"
                >
                  <v-card-title class="title">Posted</v-card-title>
                  <v-card-subtitle>
                    <p class="pa-0 ma-0 custom-font" v-for="(total, index) in posted" :key="index">
                      {{total.title}}: {{total.value | thousandSeprator}}
                    </p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="4" sm="6" md="4">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="#363636"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                  min-height="195px"
                >
                  <v-card-title class="title">Posted Deliverables</v-card-title>
                  <v-card-subtitle>
                    <p class="pa-0 ma-0 custom-font" v-for="(total, index) in postedDeliverables" :key="index">
                      {{total.title}}: {{total.value | thousandSeprator}}
                    </p>
                  </v-card-subtitle>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-layout>
        <v-row class="mb-3 mt-3">
          <v-col cols="12" sm="3" md="3" lg="3">
            <v-btn color="success" small class="mb-2" v-if="!disableSave" @click="saveChanges()">Save Changes</v-btn>
            <v-btn color="warning" small class="mb-2" v-if="!disableSave" @click="cancelEdit()">Cancel</v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2">
            <v-select
              :items="YesNoOptions"
              item-text="text"
              item-value="value"
              label="Completed Form"
              v-model="customFilter.completedForm"
              filled
              dense
              small
              hide-details
              @change="getFiltered()"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2">
            <v-select
              :items="YesNoOptions"
              item-text="text"
              item-value="value"
              label="Review in IMS"
              v-model="customFilter.imsReview"
              filled
              dense
              hide-details
              @change="getFiltered()"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="5" md="5" lg="5">
            <v-card-title class="pa-0">
              <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
          </v-col>
        </v-row>
        <!-- BEGIN Report Pairing Influencer table -->
          <v-data-table
            :headers="headers" 
            :search="filter" 
            :items="filteredItems" 
            class="elevation-1"
            :loading="loading"
            @current-items="getDataTableFiltered">
            <template v-slot:no-data>No Data</template>
            <template v-slot:[`item.handle`]="{ item }">
              <td class="text-left">
                <a
                  :href="'https://www.tiktok.com/@' + item.handle"
                  target="_blank"
                  v-if="item.platform === 'tiktok'"
                ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.handle}}</a>
                <a
                  :href="'https://www.instagram.com/' + item.handle"
                  target="_blank"
                  v-else
                ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{item.handle}}</a>
              </td>
            </template>
            <template v-slot:[`item.followers`]="{ item }">
              <td class="text-center">
                {{item.followers | thousandSeprator}}
              </td>
            </template>
            <template v-slot:[`item.completedForm`]="{ item }">
              <td class="text-center">
                <div class="item-edit" @click="openEditItem(item, 'completedForm')" v-if="item.completedFormEdit === false">
                  <span class="text-center">
                    {{completedFormText(item.completedForm)}}
                  </span>
                </div>
                <div v-else>
                  <td class="text-xs-left" style="min-width:50px">
                    <v-select
                      class="input-field pt-3"
                      v-model="item.completedForm"
                      :items="getCompletedFormOptions"
                      item-value="value"
                      item-text="text"
                      label="Completed Form"
                      dense
                      outlined
                    ></v-select>
                  </td>
                </div>
              </td>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <td class="text-center">
                {{getStatusText(item.pairingStatus)}}
              </td>
            </template>
            <template v-slot:[`item.imsReview`]="{ item }">
              <td class="text-center">
                {{item.imsReview ? 'YES' : 'NO'}}
              </td>
            </template>
            <template v-slot:[`item.numberOfReviews`]="{ item }">
              <td class="text-center">
                {{item.numberOfReviews}}
              </td>
            </template>
            <!-- Start Footer Area -->
            <template slot="body.append">
              <tr>
                <th class="subtitle-2">Total:</th>
                <th class="text-center">
                  {{totals.followers | thousandSeprator}}
                </th>
                <th></th>
                <th class="text-center">
                  {{totals.completedForm}}
                </th>
                <th class="text-center">
                  {{totals.imsReview}}
                </th>
                <th></th>
                <th class="text-center">
                  {{totals.numberOfReviews | thousandSeprator}}
                </th>
              </tr>
            </template>
          </v-data-table>
        <!-- End Report Pairing Influencer table -->
        <!-- <v-layout class="mt-2" wrap>
          <v-flex class="subtitle-1" xs12 md12>
            Total Influencers: {{total.influencers | thousandSeprator}}
          </v-flex>
          <v-flex class="subtitle-1" xs12 md12>
            Total Followers: {{total.followers | thousandSeprator}}
          </v-flex>
          <v-flex class="subtitle-1" xs12 md12>
            Total Reviewers: {{total.reviewers | thousandSeprator}}
          </v-flex>
        </v-layout> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import moment from 'moment'
import { mapGetters } from 'vuex';
import pairingAPIs from '../../Pairing/pairingAPIs';
export default {
  name: 'InfluencerTable',
  props: [
    'headers',
    'filteredItems',
    'filter',
    'loading',
    'value',
    'campaign',
    'overall',
    'posted',
    'postedDeliverables',
    'totals'
  ],
  data () {
    return {
      disableSave: true,
      isLoading: false,
      completedFormOptions: [
        {
          text: 'YES',
          value: 1
        },
        {
          text: 'NO',
          value: 0
        }
      ],
      YesNoOptions: [
        {
          text: 'All',
          value: ''
        },
        {
          text: 'YES',
          value: 1
        },
        {
          text: 'NO',
          value: 0
        }
      ],
      customFilter: {
        completedForm: '',
        imsReview: ''
      }
    }
  },
  mounted() {
  },
  watch: {
    value(newValue) {
      this.unsetItemEdits()
    }
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    getCompletedFormOptions() {
      return Object.assign([], this.completedFormOptions)
    }
  },
  methods: {
    saveChanges() {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          const formData = this.buildFormData();
          // Submit request to save updated AOK Report data
          pairingAPIs
          .updatePairings(formData)
          .then(response => {
            // Update submitting status
            this.isLoading = false;
            // this.getPaymentConsolidateReport()
            this.cancelEdit()
            // Show success message
            this.$swal({
              text: 'Successfully Updated',
              type: 'success'
            });
          })
          .catch(error => {
            // Update submitting status
            this.isLoading = false;
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    buildFormData() {
      let editedItems = this.filteredItems.filter(item => {
        return item.editReport
      })
      let updatePairings = []
      editedItems.map(item => {
        updatePairings.push(Object.assign({}, {
          id: item.pairingID,
          completedForm: item.completedForm
        }))
      })
      let formData = new FormData();
      formData.append('pairings', JSON.stringify(updatePairings));
      return formData
    },
    unsetItemEdits() {
      this.filteredItems = this.filteredItems.map(item => {
        item = this.setDefaultEditFields(item)
        return item
      })
    },
    setDefaultEditFields(item) {
      item.completedFormEdit = false;
      return item;
    },
    cancelEdit() {
      this.unsetItemEdits()
      this.disableSave = true
    },
    openEditItem(item, itemName) {
      item[itemName + 'Edit'] = true
      item.editReport = true
      this.disableSave = false
      this.filteredItems = Object.assign([], this.filteredItems)
    },
    getStatusText(status) {
      let statusTxt = ''
      Object.entries(this.pairingStatus).forEach(item => {
        if (item[1].value === status) {
          statusTxt = item[1].text
        }
      });
      return statusTxt
    },
    completedFormText(status) {
      return status > 0 ? 'YES' : 'NO'
    },
    getFiltered() {
      this.$emit('filtered', this.customFilter)
    },
    getDataTableFiltered(filtered) {
      this.$emit('dataTableFiltered', filtered)
    },
    close() {
      this.$emit('input')
      this.$emit('closed')
    }
  }
}
</script>



// WEBPACK FOOTER //
// InfluencerModal.vue?636f17af